import React, { Component } from 'react';
import {parseShowPageModule} from './helpers';
import ListItemDetailed from '~/components/ListItemDetailed';
import '~/assets/css/fitness-globals.scss';
import './styles.scss';
import Slider from 'react-slick';
import { InstagramIcon, TwitterIcon, FacebookIcon, BackArrowIcon, FollowHeartIcon, ShareIcon } from '~/assets/svg';
import AccordionItem from '~/components/AccordionItem';
import { getFollows, follow, unfollow } from "~/redux/user/follows";
import userStore from '~/redux/user/store';
import connect from "~/tools/connect";
import share from '~/tools/share';

class ConceptDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...parseShowPageModule(props.data.contentData[0]),
      follows: false
    }
  }

  componentDidMount() {
    if(this.state.user){
      getFollows().then( (res) => {
        if(res.records.filter( r => r.contentId === this.state.id).length > 0){
          this.setState({...this.state, follows: true});
        }
      }); 
    }
  }

  goBack() {
    window.history.back();
  }

  toggleFollow(){
    if(this.state.follows){
      unfollow(this.state.id).then( res => {
      });
      this.setState({...this.state, follows: false});
    }
    else{
      follow(this.state.id, this.state.contentType, this.state.title).then( res => {
      });
      this.setState({...this.state, follows: true});
    }
  }

  handleShare(){
    share['email'](this.props.path, this.props.title);
  }

  render() {
    return (
      <div className="concept-detail">
        <div className="module-header">
          <div className="left">
            <a onClick={this.goBack} className="back-arrow"><BackArrowIcon/></a>
          </div>
          {this.state.title.toUpperCase()}
          <div className="right">
            {this.state.user && <a 
              onClick={this.toggleFollow.bind(this)} 
              className={"follow-button " + (this.state.follows ? "followed" : '')}>
              <FollowHeartIcon/>
              </a>
            }
            <a onClick={this.handleShare.bind(this)} className="share-button"><ShareIcon/></a>
          </div>
        </div>

        <div className="module-content">
          <div className="left">
            <div className="carousel">
              <Slider
                dots={true}
                infinite={false}
                arrows={false}
                slidesToShow={1}>
                <div><div className="fixed-ratio-slide"><img src={this.state.image}/></div></div>
              </Slider>
            </div>
            <AccordionItem title={"About this Concept"}>
              <p>{this.state.description}</p>
            </AccordionItem>
            <AccordionItem title={`Meet Your ${this.state.instructors.length > 1 ? 'Instructors': 'Instructor'}`}>
              {this.state.instructors.map((i) => {
                return <div key={i.id} className="instructor box-content">
                  <h2>
                    {i.firstName} {i.lastName} 
                    <div className="social-icons">
                      {i.instagramUrl != null && <a className="social-link" href={i.instagramUrl}><InstagramIcon/></a>}
                      {i.twitterUrl != null && <a className="social-link" href={i.twitterUrl}><TwitterIcon/></a>}
                      {i.facebookUrl != null && <a className="social-link" href={i.facebookUrl}><FacebookIcon/></a>}
                    </div>
                  </h2>
                  <div dangerouslySetInnerHTML={{__html: i.body}} />
                </div>
              })}
            </AccordionItem>
          </div>

          <div className="right">
            <div className="detailed-list-header">ALL CLASSES <span className="content-count">({this.state.videos.length})</span></div>
            <div className="list-content detailed-item-list">
              {this.state.videos.map((c, i) => {
                return <ListItemDetailed key={i} showBookmark={true} addToCalender={false} item={c} showPlayIcon={true} conceptTitle={this.state.title.toUpperCase()}/>
              })}
            </div>
          </div>

        </div>
      </div>
    )
  }
}

connect(ConceptDetail, state => ({ user: state.user }), userStore);

export default ConceptDetail;